module.exports = __webpack_public_path__ + "static/media/nft3-nft.da3aa15d.mp4";